import { render, staticRenderFns } from "./addSpecification.vue?vue&type=template&id=302fc379&scoped=true&"
import script from "./addSpecification.vue?vue&type=script&lang=js&"
export * from "./addSpecification.vue?vue&type=script&lang=js&"
import style0 from "./addSpecification.vue?vue&type=style&index=0&id=302fc379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302fc379",
  null
  
)

component.options.__file = "addSpecification.vue"
export default component.exports